import { render, staticRenderFns } from "./IconBtn.vue?vue&type=template&id=32d9e81e&scoped=true"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"
import style0 from "./IconBtn.vue?vue&type=style&index=0&id=32d9e81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9e81e",
  null
  
)

export default component.exports